// @ts-nocheck
export const API_PATHS = {
  getWorkingHours: '/umbraco/api/WorkingHours/GetWorkingHoursAndTimezone?userId=',
  updateWorkingHours: '/umbraco/api/WorkingHours/UpdateWorkingHoursAndTimezone?userId=',
};
